// src/types/retailReview.ts
// Retail (Shopaholic) buyer review model. Reviews are one-way (buyer → shop)
// and published immediately once verified against a real paid order.

export const RETAIL_REVIEW_TAGS = [
  'great_product',
  'good_value',
  'fast_processing',
  'great_communication',
  'accurate_description',
  'smooth_delivery',
] as const;
export type RetailReviewTag = (typeof RETAIL_REVIEW_TAGS)[number];

export type RetailReviewStatus = 'pending' | 'approved' | 'rejected';

export interface RetailReview {
  id: string;
  profileId: string;
  /** Signed-in buyer UID when the reviewer had an account. */
  reviewerId?: string;
  reviewerName: string;
  rating: number; // 1–5
  body: string;
  tags?: RetailReviewTag[];
  purchasedProductName?: string;
  /** Always true: retail reviews are only accepted from verified (paid) buyers. */
  isVerifiedBuyer: boolean;
  verifiedOrderId: string;
  status: RetailReviewStatus;
  createdAt: string; // ISO string (serialized from Firestore Timestamp for client transfer)
}